import { BaseGetRequest } from './core/baseGetRequest';
import { AccountLinksList, AccountLinksListDynamicType } from '../models/accountLinksList';

export class AccountLinksRequest extends BaseGetRequest<AccountLinksList> {
    constructor() {
        super('/account-links', {}, AccountLinksListDynamicType);
    }
}
